import { IconType } from "react-icons";
import { AiOutlineClose } from "react-icons/ai";
import { HiMagnifyingGlass } from 'react-icons/hi2';

interface SearchProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onSubmitSearch?: () => void;
  onClickAction?: () => void;
  onClickClean?: () => void;
  Icon?: IconType;
  showSearch?: boolean;
  buttonText?: string;
  search?: string;
}

export const SearchBanner: React.FC<SearchProps> = (props) => {
  const { showSearch = true, Icon, buttonText, onSubmitSearch, onClickAction, onClickClean, search, ...rest } = props;
  return (
    <div className="gm-search-banner-container">
      <form onSubmit={onSubmitSearch}>
        <div className="gm-search-input-container">
          {showSearch &&
            <div>
              <div>
                <HiMagnifyingGlass />
                <input name='search' {...rest} />
              </div>
              {onClickClean && search && <button type="button" onClick={onClickClean}><AiOutlineClose size={18} /></button>}
            </div>
          }
        </div>
        <button type="button" onClick={onClickAction}>
          {buttonText || ''}
          {Icon && <Icon size={18} />}
        </button>
      </form>
    </div>
  )
};